export default "__VITE_ASSET__DEjezfGE__"